import { h, Component } from "preact";
import { route } from "preact-router";
import { Link } from "preact-router/match";
import { Text } from "preact-i18n";

import DatabasesNav from "../databases-nav";

import style from "./style.css";
import { NL_STRING, EN_STRING } from "../..";

class Header extends Component {
  state = {
    current: NL_STRING,
    [NL_STRING]: "Nederlands",
    [EN_STRING]: "English"
  };

  componentDidMount = () => {
    if (this.props.locale) {
      this.setState(previousState => ({
        ...previousState,
        current: this.props.locale
      }));
    }
  };

  switchLanguage = () => {
    const currentLocale = this.state.current;
    const newLocale = currentLocale === NL_STRING ? EN_STRING : NL_STRING;

    this.setState(previousState => {
      return {
        ...previousState,
        current: newLocale
      };
    });
    this.props.langSwitchClick(newLocale);

    // route(`/${newLocale}`, true);
    window.location = `/${newLocale}`;
  };

  getLangToSwitchTo = (locale = NL_STRING) => {
    return locale === NL_STRING ? this.state[EN_STRING] : this.state[NL_STRING];
  };

  getSwitchLink(locale = NL_STRING) {
    const newLocale = locale === NL_STRING ? EN_STRING : NL_STRING;
    return `/${newLocale}`;
  }

  render({ locale }) {
    return (
      <header class={style.header}>
        <div class={style["nav-wrap"]}>
          <DatabasesNav locale={locale} />
          <nav class={style["nav--main"]} aria-label="Main">
            <Link
              class={style["nav--main__item"]}
              activeClassName={style.active}
              href={`/${locale}`}
            >
              Home
            </Link>
            <a
              class={style["nav--main__item"]}
              href={`/${locale}/admin/roman/literature`}
              native
            >
              Admin
            </a>

            <a
              class={style["nav--main__item"]}
              href={this.getSwitchLink(locale)}
              native
            >
              {this.getLangToSwitchTo(locale)}
            </a>
          </nav>
        </div>
        <h1 class="title--page">
          <Text id="headings.Literatuur en Geneeskunde">
            Literatuur en Geneeskunde
          </Text>
        </h1>
      </header>
    );
  }
}

export default Header;
